@for (item of history; track item) {
  <div class="comment">
    <div class="comment-header">
      <span class="date">{{ dateTimeHelper.getFormattedDate(item?.CreTs) }}
        @if (language !== 'it') {
          <span>
            <span fiTranslation="REQUEST_DETAIL_HISTORY_TIME_FROM_BEFORE_TIME_1"></span>
            <span>&nbsp;</span>
            <span fiTranslation="REQUEST_DETAIL_HISTORY_TIME_FROM_BEFORE_TIME_2"></span>
          </span>
        }
        @if (language === 'it') {
          <span fiTranslation="REQUEST_DETAIL_HISTORY_TIME_FROM_BEFORE_TIME_2"></span>
        }
      </span>
      <span class="contact"> {{ item?.Creator.FirstName + ' ' + item?.Creator.LastName }} - {{ item?.Creator.Organisation }}</span>
      <span class="request-info"><span
      fiTranslation="REQUEST_DETAIL_HISTORY_LEAD_CREATE_DATE"></span> {{ item?.Number }}</span>
    </div>
    <p class="action-box">
      <span class="action-icon">
        <img [src]="LeadHelper.getAssetImage(item?.LeadTypeId)" alt="action-icon">
      </span>
      <b class="author">{{ item.LeadTypeText }}</b>
    </p>
    @if (item.Articles?.length) {
      <div class="articles-list">
        @for (article of item.Articles; track article) {
          <div class="article-item">{{ article.Article }} - {{ article.Description }}
          </div>
        }
      </div>
    }
    <p class="note-box">
      <span class="note is-html-snippet" fiTranslation="REQUEST_DETAIL_HISTORY_RELATED_ENQUIRIES_TEXT_CREATED"></span>
    </p>
  </div>
}
